import type { ProgressionSchema } from '@/types/schema';

import { getServices } from '~/db/services';

export const useMyFutureEmptySyncGet = () => {
  const { $db } = useNuxtApp();
  const { sponsorInfosService } = getServices($db);

  const request = ref<() => Promise<number>>(() => {
    try {
      return sponsorInfosService.count();
    } catch (e) {
      if (e.name === 'DatabaseClosedError') {
        globalThis.$logger.info('useProgressionsSyncGet :: error', e);
      } else {
        throw e;
      }
    }
  });

  const { value: count, release } = useLiveQuery<number>(request.value, ref());

  const isMyFutureEmpty = computed(() => {
    return count.value === 0 || count.value == null;
  });

  $db.progressions.hook('deleting', () => {
    globalThis.$logger.info('progressions is deleting');
    release();
  });

  return { isMyFutureEmpty };
};
